import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';
import { useNavbar } from '../../../contexts/NavbarContext';
import ExternalLink from '../../common/ExternalLink';

const Navbar = () => {
    const { navbarLinks, logo, title, titlePath, navbarStyle } = useNavbar();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [navbar, setNavbar] = useState(false)
    const [isDropdownOpen, setIsDropdownOpen] = useState(false); // New state for dropdown


    // Close the menu when the window is resized to be wider than the mobile view
    useEffect(() => {
        document.body.style.backgroundColor = navbarStyle.bodyBackgroundColor;

        // console.log("usefefct")
        changeBackground()
    
        const handleResize = () => {
            if (window.innerWidth > 768) {
                setIsMenuOpen(false);
            }
        };

        window.addEventListener("scroll", changeBackground)
        window.addEventListener('resize', handleResize);

        return () => {
            window.addEventListener("scroll", changeBackground)
            window.removeEventListener('resize', handleResize);
        };
    }, [navbarStyle.bodyBackgroundColor]);

    useEffect(() => {
        const onScroll = (event) => {
            // console.log(window.pageYOffset)
            // console.log(window.screenY)
            // console.log(window.scrollY)
            // console.log(document.pageYOffset)
            // console.log(document.screenY)
            // console.log(document.scrollY)
            if (document.pageYOffset > 0){
                // console.log(document.pageYOffset)
                
            }
        }

        document.addEventListener('scroll', onScroll, true)

    })

    if (!navbarLinks || !logo || !title) {
        return null;
    }

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const changeBackground = () => {
        // console.log(window.pageYOffset)
        if (window.pageYOffset > 0) {
          setNavbar(true)
        //   console.log("truee")
        } else {
          setNavbar(false)
        //   console.log("falsee")
        }
    }
    

    return (
        <nav className={navbar ? "nav active" : "nav"}
        style={{
            color: navbarStyle.color,
            backgroundColor: navbar ? navbarStyle.backgroundColorSecondary : navbarStyle.backgroundColor,
            position: navbarStyle.position,
        }}>
            {/* <button color="red" onClick={changeBackground}></button> */}
            <div className="navbar-left">
                <div className={`hamburger ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>
                <Link to={titlePath} className="site-title">
                    <img src={logo} alt="Logo" className="navbar-logo" />
                </Link>
                <Link to={titlePath} className="site-title">
                    {title}
                </Link>
            </div>
            {!isMenuOpen && (
                <div className="navbar-links">
                    {navbarLinks.menu && (
                        <CustomLink to={navbarLinks.menu.path}>
                            {navbarLinks.menu.label}
                        </CustomLink>
                    )}

                    {navbarLinks.restaurants && (
                        <div className="dropdown" onMouseEnter={toggleDropdown} onMouseLeave={toggleDropdown}>
                            <button className="dropbtn">
                                Restaurants 
                                <div className="fa-solid fa-chevron-down"></div>
                            </button>
                            {isDropdownOpen && (
                                <div className="dropdown-content">
                                    {navbarLinks.restaurants.map((restaurant, index) => (
                                        <Link key={index} to={restaurant.path}>
                                            {restaurant.label}
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}

                    {/* {navbarLinks.restaurants && (
                        <CustomLink to={navbarLinks.restaurants.path}>
                            {navbarLinks.restaurants.label}
                        </CustomLink>
                    )} */}
                    {navbarLinks.map && (
                        navbarLinks.map.isExternal ? (
                            <ExternalLink to={navbarLinks.map.path} className="nav-link">
                                {navbarLinks.map.label}
                            </ExternalLink>
                        ) : (
                            <CustomLink to={navbarLinks.map.path}>
                                {navbarLinks.map.label}
                            </CustomLink>
                        )
                    )}
                    <CustomLink to={navbarLinks.about.path}>
                        {navbarLinks.about.label}
                    </CustomLink>
                    <CustomLink to={navbarLinks.contact.path}>
                        Contact Us
                    </CustomLink>
                </div>
            )}
            <div className={`overlay-menu ${isMenuOpen ? 'open' : ''}`}>
                <div className="overlay-content">
                    {navbarLinks.menu && (
                        <CustomLink to={navbarLinks.menu.path} onClick={toggleMenu}>
                            {navbarLinks.menu.label}
                        </CustomLink>
                    )}
                    {navbarLinks.restaurants && (
                        // <CustomLink to={navbarLinks.restaurants.path} onClick={toggleMenu}>
                        //     {navbarLinks.restaurants.label}
                        // </CustomLink>
                        <div className="dropdown">
                            {/* <button className="dropbtn" onClick={toggleDropdown}>
                                Restaurants
                            </button> */}
                            {isDropdownOpen && (
                                <div className="dropdown-content">
                                    {navbarLinks.restaurants.map((restaurant, index) => (
                                        <Link key={index} to={restaurant.path} onClick={toggleMenu}>
                                            {restaurant.label}
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                    {navbarLinks.map && (
                        navbarLinks.map.isExternal ? (
                            <ExternalLink to={navbarLinks.map.path} className="nav-link" onClick={toggleMenu}>
                                {navbarLinks.map.label}
                            </ExternalLink>
                        ) : (
                            <CustomLink to={navbarLinks.map.path} onClick={toggleMenu}>
                                {navbarLinks.map.label}
                            </CustomLink>
                        )
                    )}
                    <CustomLink to={navbarLinks.about.path} onClick={toggleMenu}>
                        {navbarLinks.about.label}
                    </CustomLink>
                    {/* <CustomLink to="/contact" onClick={toggleMenu}> */}
                    <CustomLink to={navbarLinks.contact.path} onClick={toggleMenu}>
                        Contact Us
                    </CustomLink>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;

function CustomLink({ to, children, onClick, ...props }) {
    const resolvedPath = useResolvedPath(to);
    const isActive = useMatch({ path: resolvedPath.pathname, end: true });

    return (
        <Link
            to={to}
            className={isActive ? 'nav-link active' : 'nav-link'}
            onClick={onClick}
            {...props}
        >
            {children}
        </Link>
    );
}

